export class Religion{
    id : number;
    nationalityCode : string;
    nationalityName : string;  
} 